export default "__VITE_ASSET__DQ6QWJvY__"